export const siteConfig = {
  siteName: "Data Science Club - SMS TU",
  clubName: "Data Science Club",
  institution: "School of Mathematical Sciences, Tribhuvan University",
  contactEmail: "contact@datascienceclub.sms.tu.edu.np",
  // TODO before production: replace "#" values with official DSC social profile URLs.
  socialLinks: {
    github: "#",
    linkedin: "#",
    twitter: "#",
    facebook: "#",
    instagram: "#",
    discord: "#",
  },
} as const;
